import { render, staticRenderFns } from "./CustomerAddContact.vue?vue&type=template&id=72e910b4&scoped=true&"
import script from "./CustomerAddContact.vue?vue&type=script&lang=js&"
export * from "./CustomerAddContact.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddContact.vue?vue&type=style&index=0&id=72e910b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e910b4",
  null
  
)

export default component.exports